export { APP_REACH_HEADER, api, apiBaseUrl, getAccessToken, setAccessToken } from './api.ts';
export {
  BOARD_TERMINAL,
  BuildRequestButton,
  BuildRequestDialog,
  ProjectAssistantDialog,
  boardCards,
  provideBoard,
  type BoardKind,
  type BuildRequestInit,
  type BuildRequestLook,
} from './board.tsx';
export { ChatPanel, provideChatPanel } from './chat-panel.tsx';
export { config } from './config.ts';
export { OwnViews } from './copy-views.tsx';
export { OPEN_SEARCH_EVENT, START_TUTORIAL_EVENT, openSearch } from './events.ts';
export { CortexTourHost } from './guides.tsx';
export {
  ALERTS_CHANGED_EVENT,
  cellText,
  fmtTime,
  shortHash,
  timeAgo,
  type AlertEvent,
  type AlertRule,
  type AuditEvent,
  type DesignCommit,
  type RowChange,
  type SearchGroup,
  type TableDiff,
  type TableStat,
} from './history-types.ts';
export { LogoutIcon, ProfileIcon, ThemeIcon } from './icons.tsx';
export { type Language } from './lib/CodeEditor.tsx';
export { QrCode } from './lib/QrCode.tsx';
export { ApiFailure, ago, call, errorMessage, relative, short } from './lib/api-call.ts';
export { TimeAgo } from './lib/time-ago.tsx';
export {
  buildNav,
  flattenNav,
  isGroupActive,
  isItemActive,
  type BadgeKey,
  type NavEntry,
  type NavGroup,
  type NavItem,
} from './nav/model.ts';
export { DEFAULT_BRANCH, parseProjectPath, projectPath } from './nav/paths.ts';
export { Landing, rememberProject } from './pages/Landing.tsx';
export { NotFound } from './pages/NotFound.tsx';
export { PlaceholderPage } from './pages/Placeholder.tsx';
export {
  organizationAiCards,
  organizationGitCards,
  projectAiCards,
  projectRepositoryCards,
} from './slots.tsx';
export { CommitViewProvider, useCommitView, useReadOnlyButtons } from './state/commit-view.tsx';
export { onOutage, reconnectDelay, sessionVerdict, type SessionVerdict } from './state/connection.ts';
export {
  agentRunsKey,
  boardKey,
  designKey,
  designScope,
  invalidate,
  queryClient,
  useApiQuery,
} from './state/query.ts';
export { browserFetch, readCache, setNetworkFetch } from './state/read-cache-install.ts';
export { ThemeProvider, useTheme } from './state/theme.tsx';
export { getUiView, useUiView } from './state/ui-view.ts';
export { cspNonce, reportUncaughtErrors, shareNonce } from './telemetry.ts';
export { browserTracingOn } from './tracing/flag.ts';
export { lazyView } from './lazy-view.tsx';

/** Its pages and views the host (or another module) loads when shown. */
export const pages = {
  guides: () => import('./guides.tsx'),
  'lib/CodeEditor': () => import('./lib/CodeEditor.tsx'),
  'pages/Gallery': () => import('./pages/Gallery.tsx'),
  'tracing/browser-tracing': () => import('./tracing/browser-tracing.ts'),
};
